// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tab-container[data-v-54e082c2] {\n  margin: 30px;\n}\n\n", ""]);
// Exports
module.exports = exports;
